import React from 'react';
import { useTranslation } from 'react-i18next';
import NoResultFound from './NoResultFound';
import { BaseButton } from 'app/components/buttons/BaseButton';
import './NoResultFound.less';

interface Props {
  className?: string;
  searchText: string;
  isFilterUsed: boolean;
  onClear: () => void;
}

export default function EquipmentNoResults({
  className,
  searchText,
  isFilterUsed,
  onClear,
}: Props) {
  const { t } = useTranslation();

  return (
    <NoResultFound
      className={className}
      title={
        isFilterUsed
          ? t('no_results_found')
          : t('no_result_for', { s: searchText })
      }
      description={
        isFilterUsed &&
        t('access_sharing.table.no_results.remove_or_clear_all_filters')
      }
      action={
        isFilterUsed && (
          <BaseButton onClick={onClear} className="no-result-found__button">
            {t('access_sharing.table.no_results.clear_all_filters')}
          </BaseButton>
        )
      }
    />
  );
}
